export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Scuba Diving Instructor Ready after purchasing?',
    a: ['You receive digital access to the complete material after your purchase is completed.'],
  },
  {
    q: 'Is this a course to become a scuba instructor?',
    a: [
      'No.',
      'Scuba Diving Instructor Ready is created for existing scuba instructors and dive educators who want ready-to-use teaching resources for their students.',
    ],
  },
  {
    q: 'Is this an app?',
    a: [
      'No.',
      'It is a digital teaching system delivered as organized resources and PDF materials. The Class Finder shown in the presentation represents the organized lesson-finding experience of the system.',
    ],
  },
  {
    q: 'Is this visual or mostly text?',
    a: [
      'The system is designed to be 100% visual, with diagrams, underwater positions, teaching sequences, comparisons, drills, cues, assessment tools and visual references.',
    ],
  },
  {
    q: 'Does it include videos?',
    a: ['No.', 'The product consists of digital instructional materials and PDFs.'],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes.', 'The complete system is in English.'],
  },
  {
    q: 'Can I edit the PDFs?',
    a: ['No.', 'The material is delivered as finished PDF resources.'],
  },
  {
    q: 'Is it only for complete beginners?',
    a: [
      'No.',
      'The system progresses from beginner foundations through more developed underwater skills and increasingly independent student performance.',
    ],
  },
  {
    q: 'Does this replace certification-agency training standards?',
    a: [
      'No.',
      'Scuba Diving Instructor Ready is supplementary teaching support for qualified instructors.',
      "All training must continue to follow the instructor's certification-agency standards, approved manuals, equipment guidance, local regulations and professional judgment.",
    ],
  },
]
